import { TailSpin } from "react-loader-spinner";
import React, { FC } from "react";

type typeMyLoader = {
  loading: boolean;
}

const MyLoader:FC<typeMyLoader> = ({ loading , children}) => {
  return (
    <div style={{ position: 'relative' }}>
      {loading && (
        <div style={{
          position: 'absolute',
          top: 0, left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255,255,255,0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
        }}>
          <TailSpin color="#164192" height={80} width={80} />
        </div>
      )}
      {children}
    </div>
  );
}

export { MyLoader };
